export const MAX_BANDWIDTH = 2048
export const MIN_BANDWIDTH = 224
export const VIDEO_HEIGHT = 720
export const ASPECT_RATIO = 4 / 3
